import { QueryHookOptions, useQuery } from 'react-apollo';
import { LIST_PLACES_QUERY } from './list-places-query';
import { ListPlacesData } from './list-places-data';
import { ListPlacesVariables } from './list-places-variables';

export const useListPlacesQuery = (
  variables: ListPlacesVariables,
  options?: Omit<
    QueryHookOptions<ListPlacesData, ListPlacesVariables>,
    'variables' | 'query'
  >,
) =>
  useQuery<ListPlacesData, ListPlacesVariables>(LIST_PLACES_QUERY, {
    ...options,
    variables,
  });
